import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const SEOHead = () => {
  const location = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    // Update document title based on route
    const updateTitle = () => {
      const titles = {
        '/': language === 'en'
          ? 'Global Limousine - Premium Limousine Service in Egypt | Luxury Transportation'
          : 'جلوبال ليموزين - خدمة الليموزين الفاخرة في مصر | النقل الفاخر',
        '/book': language === 'en'
          ? 'Book a Ride - Global Limousine | Reserve Your Luxury Transportation'
          : 'احجز رحلتك - جلوبال ليموزين | احجز النقل الفاخر',
        '/cars': language === 'en'
          ? 'Our Fleet - Luxury Vehicles | Global Limousine'
          : 'أسطولنا - سيارات فاخرة | جلوبال ليموزين',
        '/destinations': language === 'en'
          ? 'Popular Destinations - Global Limousine | Egypt Travel'
          : 'الوجهات الشعبية - جلوبال ليموزين | السفر في مصر',
        '/reviews': language === 'en'
          ? 'Customer Reviews - Global Limousine | Testimonials'
          : 'آراء العملاء - جلوبال ليموزين | شهادات',
        '/contact': language === 'en'
          ? 'Contact Us - Global Limousine | Get in Touch'
          : 'اتصل بنا - جلوبال ليموزين | تواصل معنا',
        '/payment': language === 'en'
          ? 'Payment - Global Limousine | Secure Payment'
          : 'الدفع - جلوبال ليموزين | دفع آمن',
      };

      const title = titles[location.pathname] || titles['/'];
      document.title = title;

      // Update meta description
      const descriptions = {
        '/': language === 'en'
          ? 'Global Limousine offers premium limousine and luxury car rental services in Egypt. Book your ride for airport transfers, city tours, weddings, and special events. Professional drivers, luxury vehicles, and 24/7 service available.'
          : 'جلوبال ليموزين تقدم خدمات الليموزين الفاخرة وتأجير السيارات الفاخرة في مصر. احجز رحلتك لنقل المطار، جولات المدينة، حفلات الزفاف، والفعاليات الخاصة. سائقون محترفون، سيارات فاخرة، وخدمة على مدار الساعة.',
        '/book': language === 'en'
          ? 'Book your luxury limousine ride in Egypt. Choose from our premium fleet of vehicles for airport transfers, city tours, weddings, and special events. Easy online booking available 24/7.'
          : 'احجز رحلة الليموزين الفاخرة في مصر. اختر من أسطولنا الفاخر من السيارات لنقل المطار، جولات المدينة، حفلات الزفاف، والفعاليات الخاصة. حجز سهل عبر الإنترنت متاح على مدار الساعة.',
        '/cars': language === 'en'
          ? 'Explore our luxury fleet of limousines and premium vehicles. From sedans to VIP limousines, we have the perfect vehicle for your needs in Egypt.'
          : 'استكشف أسطولنا الفاخر من الليموزين والسيارات الفاخرة. من السيدان إلى الليموزين الفاخرة، لدينا السيارة المثالية لاحتياجاتك في مصر.',
        '/destinations': language === 'en'
          ? 'Discover popular destinations in Egypt with Global Limousine. From Cairo to Alexandria, Luxor to Aswan, we provide luxury transportation to all major destinations.'
          : 'اكتشف الوجهات الشعبية في مصر مع جلوبال ليموزين. من القاهرة إلى الإسكندرية، من الأقصر إلى أسوان، نقدم النقل الفاخر لجميع الوجهات الرئيسية.',
        '/reviews': language === 'en'
          ? 'Read customer reviews and testimonials about Global Limousine service. See what our clients say about our luxury transportation services in Egypt.'
          : 'اقرأ آراء العملاء وشهاداتهم حول خدمة جلوبال ليموزين. شاهد ما يقوله عملاؤنا عن خدمات النقل الفاخرة في مصر.',
        '/contact': language === 'en'
          ? 'Contact Global Limousine for premium limousine services in Egypt. Get in touch via phone, email, or our contact form. We are available 24/7.'
          : 'اتصل بجلوبال ليموزين لخدمات الليموزين الفاخرة في مصر. تواصل معنا عبر الهاتف أو البريد الإلكتروني أو نموذج الاتصال. نحن متاحون على مدار الساعة.',
        '/payment': language === 'en'
          ? 'Secure payment options for Global Limousine services. Pay for your luxury transportation booking safely and easily.'
          : 'خيارات دفع آمنة لخدمات جلوبال ليموزين. ادفع مقابل حجز النقل الفاخر بأمان وسهولة.',
      };

      const description = descriptions[location.pathname] || descriptions['/'];
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', description);

      // Update canonical URL
      const baseUrl = 'https://globallimousineeg.com';
      const canonicalUrl = `${baseUrl}${location.pathname}`;
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('href', canonicalUrl);

      // Update language attribute
      document.documentElement.lang = language === 'ar' ? 'ar' : 'en';
      document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    };

    updateTitle();
  }, [location.pathname, language]);

  return null;
};

export default SEOHead;

